/* Match the widget's default blue focus outline to the theme without removing it. */
(() => {
  const defaultBlue = /^(?:rgb\(0,\s*24,\s*255\)|#0018ff)$/i;
  let focused;
  const observer = new MutationObserver(recolor);

  function recolor() {
    if (!focused || window.matchMedia('(forced-colors: active)').matches) return;
    if (!defaultBlue.test(focused.style.outlineColor)) return;
    focused.style.setProperty('outline-color', 'var(--sb-focus-color, #11566b)', 'important');
  }

  function watch(element) {
    observer.disconnect();
    focused = null;
    if (!(element instanceof HTMLElement) || !element.closest('#themeBody')) return;
    if (element.closest('.uwy, .userway_buttons_wrapper, [data-uw-feature-ignore]')) return;
    focused = element;
    observer.observe(element, { attributes: true, attributeFilter: ['style'] });
    recolor();
  }

  document.addEventListener('focusin', event => watch(event.target));
  document.addEventListener('focusout', () => {
    observer.disconnect();
    focused = null;
  });
  watch(document.activeElement);
})();
